import React from "react";
import { useLocation } from "react-router-dom";
import { DonateOnceHero, DonateOnceSection } from "../../components";

export default function DonateMonthly() {
	const location = useLocation();

	return (
		<>
			<DonateOnceHero monthly />

			<DonateOnceSection pathName={location.pathname} />
		</>
	);
}
